import { isContactV3ApiBetaEnabled } from '@/service/parentContacts/isContactV3ApiBetaEnabled';
import { updateAttendanceContactDeadline } from '@/service/parentContacts/updateAttendanceContactDeadline';
import { getAttendanceContactDeadline } from '@/service/parentContacts/getAttendanceContactDeadline';
import type {
  AttendanceContactDeadlineDetailResponse,
  Deadline,
} from '@/model/repository/manager/parentContacts/AttendanceContactDeadlineRepository';

/**
 * 受付締切時刻を v3 API で更新し、直後に取得して最新値を返す。
 *
 * 動作分岐:
 * - ベータフラグ OFF                       → 何もしない（undefined を返す）
 * - ベータフラグ ON + 利用申請 ON           → 何もしない（v3 API は利用申請 OFF 時のみ使用）
 * - ベータフラグ ON + 利用申請 OFF          → update → get を連続実行し最新値を返す
 *
 * エラー時は呼び出し元（controller）に例外を伝播し、controller 側で
 * serverService.errorCallback チェーンに乗せる。
 */
export const submitAttendanceContactDeadline = async (
  facilityId: string,
  isReservationResourceOff: boolean,
  payload: { deadline: Deadline; version: number }
): Promise<AttendanceContactDeadlineDetailResponse | undefined> => {
  if (!isReservationResourceOff) return undefined;
  if (!(await isContactV3ApiBetaEnabled())) return undefined;

  await updateAttendanceContactDeadline({
    facility_id: facilityId,
    version: payload.version,
    deadline: payload.deadline,
  });
  return getAttendanceContactDeadline(facilityId);
};
